import axios from "axios";
import { CREATE_ORDER_SERVER, 
  SEND_SMS_TO_CUSTOMER_SERVER,
  ORDER_DETAILS_SERVER,
  GET_ORDER_DETAILS_BY_ORDERID_SERVER,
  GET_PAYMENT_METHOD_SERVER,
  PAYMENT_BY_MOMO_SERVER,
  PAYMENT_BY_ZALO_PAY_SERVER,
} from "../../utils/misc";
import {
  CREATE_ORDER,
  SEND_SMS_TO_CUSTOMER,
  GET_ORDER_DETAILS_BY_USERNAME,
  GET_ORDER_DETAILS_BY_ORDERID,
  GET_PAYMENT_METHOD,
  PAYMENT_BY_MOMO,
  PAYMENT_BY_ZALO_PAY,
} from "./types";

export async function createOrder(dataToSubmit) {
  let token = JSON.parse(localStorage.getItem("token"));
  const headers = {
    'Accept': 'application/json',
    'Authorization':`Bearer ${token}`,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.post(CREATE_ORDER_SERVER, dataToSubmit, { headers: headers }).then((res) => {
    let result = res.data;
    return {
        result
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: CREATE_ORDER,
    payload: request,
  };
}

export async function paymentByMoMo(customerId) {
  let token = JSON.parse(localStorage.getItem("token"));
  let config = {
    headers: {
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    params: {
      CustomerId: customerId
    },
  }
  //////////////////////
  const request = await axios.get(PAYMENT_BY_MOMO_SERVER, config).then((res) => {
    let paymentResponse = res.data.data;
    return {
      paymentResponse
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: PAYMENT_BY_MOMO,
    payload: request,
  };
}

export async function paymentByZaloPay(customerId, paymentType) {
  let token = JSON.parse(localStorage.getItem("token"));
  let config = {
    headers: {
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    params: {
      CustomerId: customerId,
      PaymentType: paymentType
    },
  }
  //////////////////////
  const request = await axios.get(PAYMENT_BY_ZALO_PAY_SERVER, config).then((res) => {
    let paymentResponse = res.data.data;
    return {
      paymentResponse
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: PAYMENT_BY_ZALO_PAY,
    payload: request,
  };
}

export async function getOrderDetails() {
  let user = JSON.parse(localStorage.getItem("user"));
  const dataToSubmit = {
    UserName: user.userName
  }

  const headers = {
    'Accept': 'application/json',
    'Authorization':`Bearer`,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(ORDER_DETAILS_SERVER, { params: dataToSubmit }, { headers: headers }).then((res) => {
    let orderDetails = res.data.data;
    return {
      orderDetails
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_ORDER_DETAILS_BY_USERNAME,
    payload: request,
  };
}

export async function getOrderDetailsByOrderId(dataToSubmit) {
  const data = {
    id: dataToSubmit
  }

  const headers = {
    'Accept': 'application/json',
    'Authorization':`Bearer`,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(GET_ORDER_DETAILS_BY_ORDERID_SERVER, { params: data }, { headers: headers }).then((res) => {
    let orderDetailsByOrderId = res.data.data;
    return {
      orderDetailsByOrderId
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_ORDER_DETAILS_BY_ORDERID,
    payload: request,
  };
}

export async function getPaymentMethod() {
  const headers = {
    'Accept': 'application/json',
    'Authorization':`Bearer`,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }  
  //////////////////////
  const request = await axios.get(GET_PAYMENT_METHOD_SERVER, { headers: headers }).then((res) => {
    let paymentMethod = res.data.data;
    return {
      paymentMethod
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: GET_PAYMENT_METHOD,
    payload: request,
  };
}

export async function sendSms() {
  let userInfo = JSON.parse(localStorage.getItem("user"));
  const dataToSubmit = {
    homePhone: "+84" + userInfo.homePhone,
    fullName: userInfo.customerName,
    customerId: userInfo.customerId
  }

  let token = JSON.parse(localStorage.getItem("token"));
  const headers = {
    'Accept': 'application/json',
    'Authorization':`Bearer ${token}`,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  }    
  //////////////////////
  const request = await axios.post(SEND_SMS_TO_CUSTOMER_SERVER, dataToSubmit, { headers: headers }).then((res) => {
    let result = res.data;
    return {
        result
    };
  }).catch(err => {
    console.log(err);
  });
  return {
    type: SEND_SMS_TO_CUSTOMER,
    payload: request,
  };
}